import React from 'react';

import AboutUs from 'pages/AboutUs';
import ContactUs from 'pages/ContactUs';
import Home from 'pages/Home';
import Product from 'pages/Product';
import { ROUTE_PATHS } from 'utils/constants';

type RouteProps = {
  id: string;
  path: string;
  element: React.ReactNode;
  protected?: boolean;
};

const routes: RouteProps[] = [
  {
    id: 'home',
    path: ROUTE_PATHS.HOME,
    element: <Home />,
    protected: true,
  },
  {
    id: 'contact',
    path: ROUTE_PATHS.CONTACT,
    element: <ContactUs />,
    protected: true,
  },
  {
    id: 'aboutUs',
    path: ROUTE_PATHS.ABOUT,
    element: <AboutUs />,
    protected: true,
  },
  {
    id: 'product',
    path: ROUTE_PATHS.PRODUCT,
    element: <Product />,
    protected: true,
  },
  {
    id: 'not-found',
    path: '*',
    element: <div>404 Not Found</div>,
  }
];

export default routes;
